import axios from "axios";
import ConstantList from "app/appConfig";
const API_PATH = ConstantList.API_ENPOINT + "/api/medication";

export const pagingMedications = (searchObject) => {
  var url = API_PATH + "/pagingMedications";
  return axios.post(url, searchObject);
};

export const getMedication = (id) => {
  let url = API_PATH + "/" + id;
  return axios.get(url);
};

export const createMedication = (obj) => {
  let url = API_PATH;
  return axios.post(url, obj);
};

export const editMedication = (obj) => {
  let url = API_PATH + "/" + obj.id;
  return axios.put(url, obj);
};

export const deleteMedication = (id) => {
  let url = API_PATH + "/" + id;
  return axios.delete(url);
};

export const checkCode = (obj) => {
  let url = API_PATH + "/checkCode";
  return axios.post(url, obj);
};

export const getListMedication = (patientID) => {
  let url = API_PATH + "/list-medication/" + patientID;
  return axios.get(url);
}
